import { FC } from 'react';
import { MenuItem, SxProps, Theme } from '@mui/material';
import Select from '../../components/Select';
import { FIELD_SX } from '../../components/fieldStyles';
import { colors } from '../../theme/tokens';
import { FilterOption } from '../Home/types';
import { ROLE_LABELS, UserFilters } from './types';

// The two dropdowns of XD screen 8 besides the search box:
// "Services" and "Rôle". Inline on desktop and stacked inside the bottom
// sheet on mobile (ROADMAP.md, Part 2), with the same component.

type Props = {
  value: UserFilters;
  onChange: (patch: Partial<UserFilters>) => void;
  serviceOptions: FilterOption[];
  /** Stacked at full width (bottom sheet) or inline (desktop). */
  stacked?: boolean;
};

const CONTROL_WIDTH = 200;

const selectSx = (stacked: boolean): SxProps<Theme> => ({
  ...(FIELD_SX as object),
  width: stacked ? '100%' : CONTROL_WIDTH,
});

export const ROLE_OPTIONS: FilterOption[] = [
  { value: '', label: 'Tous' },
  { value: 'ADMIN', label: ROLE_LABELS.ADMIN },
  { value: 'USER', label: ROLE_LABELS.USER },
];

// With `displayEmpty`, the empty value ("Tous") is painted with the filter
// name in grey, which is how the XD shows the dropdowns at rest.
const renderSelected =
  (placeholder: string, options: FilterOption[]) =>
  (selected: unknown) => {
    if (!selected) {
      return <span style={{ color: colors.hint }}>{placeholder}</span>;
    }
    const found = options.find((option) => option.value === selected);
    return found ? found.label : String(selected);
  };

const UserFilterFields: FC<Props> = ({
  value,
  onChange,
  serviceOptions,
  stacked = false,
}) => (
  <>
    <Select
      size="small"
      displayEmpty
      value={value.service}
      onChange={(e) => onChange({ service: e.target.value as string })}
      renderValue={renderSelected('Services', serviceOptions)}
      inputProps={{ 'aria-label': 'Services' }}
      sx={selectSx(stacked)}
    >
      {serviceOptions.map((option) => (
        <MenuItem key={`service_${option.value}`} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>

    <Select
      size="small"
      displayEmpty
      value={value.role}
      onChange={(e) =>
        onChange({ role: e.target.value as UserFilters['role'] })
      }
      renderValue={renderSelected('Rôle', ROLE_OPTIONS)}
      inputProps={{ 'aria-label': 'Rôle' }}
      sx={selectSx(stacked)}
    >
      {ROLE_OPTIONS.map((option) => (
        <MenuItem key={`role_${option.value}`} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  </>
);

export default UserFilterFields;
